import { render, staticRenderFns } from "./Approach.vue?vue&type=template&id=d2458ad2&"
import script from "./Approach.vue?vue&type=script&lang=js&"
export * from "./Approach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports